import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown, IDocumentMastDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
// import { ILogin } from "../../models/Login";

export interface IFilterLegalTask {
  Req_ID?: number | null | string;
  Document_Type?: string | null;
  Document_Name?: string | null;
  Status?: string[] | null;
  Company?: number | null;
  Branch?: number[] | null;
  Team_Name?: number | null;
  SM?: number | null;
  Recruiter?: number | null;
  Consultant_Name?: string | null;
  Created_By?: string | null;
}

export const EmptyFilterLegalTask: IFilterLegalTask = {
  Req_ID: "",
  Document_Type: null,
  Document_Name: "",
  Status: null,
  Company: null,
  Branch: null,
  Team_Name: null,
  SM: null,
  Recruiter: null,
  Consultant_Name: "",
  Created_By: null,
};

interface IProps {
  filters: IFilterLegalTask;
  setFilters: (filters: IFilterLegalTask) => void;
}

const DocumentTypeOptions = [
  { label: "-- SELECT --", value: null },
  { label: "Vendor", value: "Vendor" },
  { label: "Client", value: "Client" },
  { label: "Consultant", value: "Consultant" },
];

const SourceTypeOption = [
  { name: "PO", value: "PO" },
  { name: "REQ", value: "REQ" },
  { name: "Other", value: "OTHER" },
];

const StatusOptions = [
  { name: "Created", value: "Created" },
  { name: "Assigned", value: "Assigned" },
  { name: "Received", value: "Received" },
  { name: "Under Review", value: "Under Review" },
  { name: "Fizzled Out", value: "Fizzled Out" },
  { name: "Negotiation in Progress", value: "Negotiation in Progress" },
  { name: "Documentation Pending", value: "Documentation Pending" },
  { name: "Executed", value: "Executed" },
  { name: "Escalated", value: "Escalated" },
  { name: "Completed", value: "Completed" },
  { name: "Approved", value: "Approved" },
  { name: "Rejected", value: "Rejected" },
  { name: "Closed", value: "Closed" },
];
const PriorityOption = [
  { name: "Low", value: 1 },
  { name: "Medium", value: 2 },
  { name: "High", value: 3 },
];

const Filter = (props: IProps) => {
  const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
  const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
  const [team, setTeam] = useState<Array<ITeamsDropdown>>();
  const [sm, setSM] = useState<Array<IUsersDropdown>>();
  const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
  const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>([]);
  const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
  const [selectedSm, setSelectedSm] = useState<any | null>(null);
  const [selectedRecruiter, setSelectedRecruiter] = useState<any | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [createdByUsers, setCreatedByUsers] = useState<Array<IUsersDropdown>>([]);
  const [assignedByUsers, setAssignedByUsers] = useState<Array<IUsersDropdown>>([]);

  //   const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

  const { control, handleSubmit, watch, reset } = useForm<IFilterLegalTask>({
    defaultValues: props.filters ?? EmptyFilterLegalTask,
  });

  const loadDocuments = async (type?: string) => {
    const response = await Fetch("Dropdown/document", "GET", null, null, null);

    if (response) {
      const data: Array<IDocumentMastDropdown> = await response.json();
      const consultant: Array<IDocumentMastDropdown> = [];
      const vendor: Array<IDocumentMastDropdown> = [];
      const client: Array<IDocumentMastDropdown> = [];

      data.forEach((d) => {
        if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
        if (d.document_Name.includes("Vendor")) vendor.push(d);
        if (d.document_Name.includes("Client")) client.push(d);
      });

      if (type === "Consultant") {
        setDocuments(consultant);
      } else if (type === "Vendor") {
        setDocuments(vendor);
      } else if (type === "Client") {
        setDocuments(client);
      } else {
        setDocuments(consultant);
      }
    }
  };

  const loadCompany = async () => {
    const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
    if (response) {
      const data: Array<ICompanyMastDropdown> = await response.json();
      data.unshift({ company_ID: 0, company_Name: "-- SELECT --" });
      setCompany(data);
    }
  };

  const loadBranch = async (companyId?: number | null) => {
    const queryParam = companyId ? `company_id=${companyId}` : null;
    const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
    if (response) {
      const data: Array<IBranchMastDropdown> = await response.json();
      data.unshift({ branch_ID: 0, branchName: "-- SELECT --", company_ID: 0 });
      setBranch(data);
    }
  };

  const loadTeam = async (branches?: number[] | null, companyId?: number | null) => {
    let queryParam = null;
    if (branches && branches.length > 0 && branches[0] !== 0) {
      queryParam = branches.map((b) => `branch_ID=${b}`).join("&");
    } else if (companyId && companyId !== 0) {
      queryParam = `company_ID=${companyId}`;
    }
    const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParam, null);
    if (response) {
      const data: Array<ITeamsDropdown> = await response.json();
      data.unshift({ team_ID: 0, team_Name: "-- SELECT --" });
      setTeam(data);
    }
  };

  const loadCreatedBy = async () => {
    const response = await Fetch("Legal_Task/usersAssignee", "GET", null, null, null);

    if (response) {
      const data: Array<IUsersDropdown> = await response.json();

      const uniqueUsers = data.filter((user, index, self) => index === self.findIndex((u) => u.user_Name === user.user_Name));

      setCreatedByUsers(uniqueUsers);
      setAssignedByUsers(uniqueUsers)
    }
  };

  const loadSm = async (branches?: number[] | null, companyId?: number | null, teamId?: number | null) => {
    let queryParam = null;
    if (teamId && teamId !== 0) {
      queryParam = `team_ID=${teamId}`;
    } else if (branches && branches.length > 0 && branches[0] !== 0) {
      queryParam = branches.map((b) => `branch_ID=${b}`).join("&");
    } else if (companyId && companyId !== 0) {
      queryParam = `company_ID=${companyId}`;
    }
    const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParam, null);
    if (response) {
      const data: Array<IUsersDropdown> = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setSM(data);
    }
  };

  const loadRecruiters = async (branches?: number[] | null, companyId?: number | null, teamId?: number | null) => {
    let queryParam = "user_Type=recruiter";
    if (teamId && teamId !== 0) {
      queryParam += `&team_ID=${teamId}`;
    } else if (branches && branches.length > 0 && branches[0] !== 0) {
      queryParam += `&${branches.map((b) => `branch_ID=${b}`).join("&")}`;
    } else if (companyId && companyId !== 0) {
      queryParam += `&company_ID=${companyId}`;
    }
    const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParam, null);
    if (response) {
      const data: Array<IUsersDropdown> = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setRecruiters(data);
    }
  };

  useEffect(() => {
    loadCompany();
    loadBranch();
    loadTeam([], 0);
    loadSm([], 0, 0);
    loadRecruiters([], 0, 0);
    loadDocuments();
    loadCreatedBy();
  }, []);

  useEffect(() => {
    if (selectedBranch.length > 0) {
      loadTeam(selectedBranch, 0);
      loadSm(selectedBranch, 0, 0);
      loadRecruiters(selectedBranch, 0, 0);
    }
  }, [selectedBranch]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "Document_Type") {
        if (value.Document_Type === "Vendor") {
          loadDocuments("Vendor");
        } else if (value.Document_Type === "Client") {
          loadDocuments("Client");
        } else if (value.Document_Type === "Consultant" && value.Document_Type != null) {
          loadDocuments("Consultant");
        } else {
          setDocuments([]);
        }
      }

      if (name === "Company") {
        if (value.Company && value.Company !== 0) {
          loadBranch(value.Company);
          loadTeam([], value.Company);
          loadSm([], value.Company, 0);
          loadRecruiters([], value.Company, 0);
        } else {
          loadBranch();
          loadTeam([], 0);
          loadSm([], 0, 0);
          loadRecruiters([], 0, 0);
        }
      }

      if (name === "Team_Name") {
        if (value.Team_Name && value.Team_Name !== 0) {
          loadSm([], 0, value.Team_Name);
          loadRecruiters([], 0, value.Team_Name);
        } else {
          loadSm(selectedBranch, value.Company, 0);
          loadRecruiters(selectedBranch, value.Company, 0);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, selectedBranch]);

  const onSubmit = (data: IFilterLegalTask) => {
    let filterData: any = { ...data };
    if (selectedBranch.length > 0) filterData.Branch = selectedBranch;
    filterData.SM = selectedSm;
    filterData.Recruiter = selectedRecruiter;
    filterData.Status = selectedStatus.length > 0 ? selectedStatus : null;
    const empty: any = EmptyFilterLegalTask;
    for (const key in filterData) {
      if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
        filterData[key] = empty[key] ?? null;
      }
    }

    if (filterData.Req_ID === "" || filterData.Req_ID === undefined) {
      filterData.Req_ID = null;
    } else {
      filterData.Req_ID = Number(filterData.Req_ID);
    }

    props.setFilters(filterData);
  };

  const onClear = () => {
    reset(EmptyFilterLegalTask);
    setSelectedBranch([]);
    setSelectedSm(null);
    setSelectedRecruiter(null);
    setSelectedStatus([]);
    loadBranch();
    loadTeam([], 0);
    loadSm([], 0, 0);
    loadRecruiters([], 0, 0);
    props.setFilters(EmptyFilterLegalTask);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVInput column={6} label="Req ID" control={control} name="Req_ID" />
      {/* <JVInput column={6} label="Consultant Name" type="text" control={control} name="Consultant_Name" /> */}
      <JVDropdown column={6} label="Source Type" control={control} name="SourceType" options={SourceTypeOption} optionLabel="name" optionValue="value" placeholder="-- Select Source Type --" />
      <JVDropdown column={6} label="Document Type" control={control} name="Document_Type" options={DocumentTypeOptions} optionLabel="label" optionValue="value" placeholder="-- Select Document Type --" />
      <JVDropdown column={6} label="Document Name" control={control} name="Document_Name" options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
      <JVDropdown column={6} label="Priority" control={control} name="Priority" options={PriorityOption} optionLabel="name" optionValue="value" placeholder="Select Priority" />
      <div className="field col-2 md:col-2">
        <label>Status</label>
        <MultiSelect value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)} options={StatusOptions} optionLabel="name" optionValue="value" filter placeholder="Select Status" maxSelectedLabels={1} className="w-full" />
      </div>
      <JVDropdown column={6} label="Company Name" control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
      <div className="field col-2 md:col-2">
        <label>Branch</label>
        <MultiSelect style={{ height: "37px", marginTop: "2px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branch} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
      </div>

      <JVDropdown filter column={6} label="Created By" control={control} name="Created_By" options={createdByUsers} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Created By" />
      <JVDropdown filter column={6} label="Assigned To" control={control} name="Assigned_To" options={assignedByUsers} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Assigned To" />
      {/* <JVDropdown column={6} label="Team Name" control={control} name="Team_Name" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team Name" /> */}
      {/* <div style={{ width: "15%", marginLeft: "10px" }}>
        <label style={{ display: "block", marginBottom: "8px" }}>Sales Manager</label>
        <Dropdown value={selectedSm} onChange={(e) => setSelectedSm(e.value)} options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" filter className="w-full" />
      </div> */}
      {/* 
      <div style={{ width: "15%", marginLeft: "10px" }}>
        <label style={{ display: "block", marginBottom: "8px" }}>Recruiter</label>
        <Dropdown value={selectedRecruiter} onChange={(e) => setSelectedRecruiter(e.value)} options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" filter className="w-full" />
      </div> */}

      <div style={{ margin: "10px 0", width: "100%" }} />
      <div
        className="col-12 md:col-12"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: "10px",
          marginTop: "10px",
        }}
      >
        <Button className="field col-12 md:col-6" label="SEARCH" type="submit" />
        <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button" />
      </div>
    </form>
  );
};

export default Filter;
